import { render } from "./SendEmails.vue?vue&type=template&id=26356924"
import script from "./SendEmails.vue?vue&type=script&lang=js"
export * from "./SendEmails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__